import React from 'react';
import { motion } from 'framer-motion';
export function TomosGrid() {
  const tomos = [{
    id: 1,
    lightColor: 'bg-violet-500/15',
    borderColor: 'border-violet-500/40',
    textColor: 'text-violet-300',
    emoji: '📘',
    title: 'El Banco de Observaciones',
    subtitle: '500+ frases técnicas listas para copiar, pegar y adaptar',
    desc: 'Lo que el 90% de los docentes nunca tuvo organizado. Más de 500 observaciones pedagógicas organizadas por nivel de desempeño (destacado, en proceso, con dificultades), área curricular y nivel educativo. Frases para Inicial, Primario y Secundario. Vocabulario técnico preciso sin lenguaje coloquial. Clasificadas por conducta, aprendizaje, participación y convivencia. Sin repeticiones ni generalidades.'
  }, {
    id: 2,
    lightColor: 'bg-purple-500/15',
    borderColor: 'border-purple-500/40',
    textColor: 'text-purple-300',
    emoji: '📘',
    title: 'Guía de Convivencia y Vínculos',
    subtitle: 'Observaciones para situaciones difíciles de decir',
    desc: 'No todas las situaciones son fáciles de documentar. Frases objetivas para describir conductas sin etiquetar ni herir. Cómo comunicar dificultades con respeto y profesionalismo. Observaciones para situaciones de conflicto entre pares, bajo rendimiento sostenido y necesidades especiales. El lenguaje que protege al docente legalmente y cuida a las familias emocionalmente.'
  }, {
    id: 3,
    lightColor: 'bg-fuchsia-500/15',
    borderColor: 'border-fuchsia-500/40',
    textColor: 'text-fuchsia-300',
    emoji: '📘',
    title: 'Kit Nivel Inicial',
    subtitle: 'Informes cualitativos para Sala de 3, 4 y 5 años',
    desc: 'El nivel con sus propias reglas de evaluación. Informes cualitativos completos por sala y período. Observaciones del desarrollo motor, lenguaje, juego simbólico y autonomía. Frases para el período de adaptación. Informes de egreso de Sala de 5 con articulación al nivel primario. Todo bajo el enfoque cualitativo vigente en Argentina 2026.'
  }, {
    id: 4,
    lightColor: 'bg-indigo-500/15',
    borderColor: 'border-indigo-500/40',
    textColor: 'text-indigo-300',
    emoji: '📘',
    title: 'Kit Nivel Primario',
    subtitle: 'Informes, boletines y registros para 1° a 6° grado',
    desc: 'El nivel con mayor cantidad de documentación. 11 informes completos del 1° al 6° grado. Observaciones por área curricular (Lengua, Matemática, Ciencias, Arte, Física). Frases específicas para Primer y Segundo Ciclo. Plantilla de boletín editable completa. Tabla de equivalencias por jurisdicción. Informe de egreso de 6° con articulación al secundario.'
  }, {
    id: 5,
    lightColor: 'bg-violet-600/15',
    borderColor: 'border-violet-600/40',
    textColor: 'text-violet-300',
    emoji: '📘',
    title: 'Kit Nivel Secundario',
    subtitle: 'Trayectorias, informes y registros para 1° a 6° año',
    desc: 'El nivel más complejo administrativamente. 11 informes completos para cada año del secundario. Observaciones por espacio curricular. Informes de Trayectoria Educativa (TEA, TEP, TER). Frases para Ciclo Básico y Ciclo Orientado. Informe de egreso de 6° año. Plantilla de Informe de Trayectoria editable. Glosario normativo 2026.'
  }, {
    id: 6,
    lightColor: 'bg-violet-400/20',
    borderColor: 'border-violet-400/50',
    textColor: 'text-violet-300',
    emoji: '⭐',
    title: 'Libro de Actas Profesional',
    subtitle: '25+ modelos de actas listos para imprimir y completar',
    desc: 'El tomo que más te va a proteger legalmente. Actas de reunión con familias (5 modelos). Actas de situaciones conductuales y acoso escolar. Actas de accidentes e incidentes escolares. Actas de reuniones institucionales y EOE. Citaciones formales. Acuerdos de convivencia individuales y grupales. Actas de vulneración de derechos. Checklist de redacción de actas y 10 errores graves a evitar.'
  }];
  return <section className="py-20 bg-zinc-900" data-id="element-322">
      <div className="container mx-auto px-4" data-id="element-323">
        <div className="text-center mb-16" data-id="element-324">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-violet-400/15 text-violet-300 border border-violet-400/30 font-bold mb-6 text-[16px]" data-id="element-325">
            🎓 MEGAPACK INFORMES DOCENTES 2026
          </div>
          <h2 className="md:text-5xl font-extrabold text-white mb-4 text-[24px]" data-id="element-326">
            6 Tomos + 4 Bonus
          </h2>
          <p className="text-zinc-200 font-medium text-[16px]" data-id="element-327">
            Del bloqueo a la fluidez. Del caos al sistema. 560+ páginas — Todo
            resuelto.
          </p>
          <p className="text-violet-300 font-medium text-sm mt-2" data-id="element-328">
            📚 Un tomo por cada dimensión del sistema
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-329">
          {tomos.map((tomo, i) => <motion.div key={tomo.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="rounded-2xl border border-violet-900/40 bg-black/70 overflow-hidden shadow-lg hover:shadow-xl hover:border-violet-700/60 transition-all flex flex-col h-full" data-id="element-330">
              <div className={`${tomo.lightColor} p-4 border-b ${tomo.borderColor} flex items-center gap-3`} data-id="element-331">
                <div className="text-2xl" data-id="element-332">{tomo.emoji}</div>
                <div data-id="element-333">
                  <p className={`text-xs font-bold uppercase tracking-wider ${tomo.textColor}`} data-id="element-334">
                    Tomo {tomo.id}
                  </p>
                  <h3 className="font-bold text-white text-lg leading-tight" data-id="element-335">
                    {tomo.title}
                  </h3>
                </div>
              </div>
              <div className="p-6 flex-grow flex flex-col" data-id="element-336">
                <p className="font-semibold text-violet-200 mb-3 pb-3 border-b border-violet-900/30" data-id="element-337">
                  {tomo.subtitle}
                </p>
                <p className="text-zinc-200 text-sm leading-relaxed" data-id="element-338">
                  {tomo.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}